import template from './service_assignment_rules.create.html';
import controller from './service_assignment_rules.create.controller';
import './service_assignment_rules.create.scss';

let ServiceAssignmentRulesCreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default ServiceAssignmentRulesCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/create/service_assignment_rules.create.component.js